import { Fragment, useState } from 'react'

import code from '../../assets/images/shortcut/code.png'
import phone from '../../assets/images/shortcut/phone.png'
import top from '../../assets/images/shortcut/top.png'

import styles from './style.module.scss'

export const Shortcut = (props) => {

    const { isScroll } = props;

    const [show, setShow] = useState(false);

    const showContent = () => setShow(true)

    const hideContent = () => setShow(false)

    const backToTop = () => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    return (
        <Fragment>
            {/* {show ? (content) : null} */}
            <div
                 className={styles['supprt-line']}
                style={{ 'opacity': `${show ? '1' : '0'}` }}
            >
                <p>咨询热线</p>
                <p>400-110-0111</p>
                <div className={styles['code-container']}>
                    <img src={code} alt="" />
                    <p>烽火星空公众号</p>
                </div>
            </div>
            <div className={styles['hotline']}
                onMouseEnter={showContent}
                onMouseLeave={hideContent}
            >
                <img src={phone} alt="" />
            </div>
            <div className={styles['backtop']}
                onClick={backToTop}
                style={{ 'display': `${isScroll ? 'block' : 'none'}` }}
            >
                <img src={top} alt="" />
            </div>
        </Fragment>
    )
}